module.exports = __webpack_public_path__ + "assets/step-2.1496cd83.svg";